/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_ComputersInputs */



/**
* | output |
* | --- |
* | "Computers" |
*
* @param {License_ComputersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_computers = /** @type {((inputs?: License_ComputersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_ComputersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ordinateurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Computer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Computer")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Компьютеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Equipos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电脑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コンピューター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कंप्यूटर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Computadores")
	return /** @type {LocalizedString} */ ("Computers")
});